import { combineReducers } from 'redux';
import authenticationReducer from './authenticationReducer';
import alertReducer from './alertReducer';
import loaderReducer from './loaderReducer';
import educationsReducer from './educationsReducer';
import workexperienceReducer from './workexperienceReducer';
import coursesReducer from './coursesReducer';
import accomplishmentsReducer from './accomplishmentsReducer';
import sportaccomplishmentsReducer from './sportaccomplishmentsReducer';
import badgesReducer from './badgesReducer';
import hobbiesReducer from './hobbiesReducer';
import membershipReducer from './membershipReducer';
import profileReducer from './profileReducer';
import connectionReducer from './connectionReducer';
import notificationsReducer from './notificationsReducer';
import portfolioReducer from './portfolioReducer';
import projectReducer from './projectReducer';
import {cvReducer} from './cvReducer';
import postReducer from './postReducer';
import myStuffReducer from './myStuffReducer';
import settingReducer from './settingReducer';



export default combineReducers({
    alertState:alertReducer,
    authenticationState:authenticationReducer,
    loaderState:loaderReducer,
    educationsState: educationsReducer,
    experienceState:workexperienceReducer,
    coursesState:coursesReducer,
    accomplishmentsState:accomplishmentsReducer,
    sportaccomplishmentsState:sportaccomplishmentsReducer,
    badgesState:badgesReducer,
    hobbiesState:hobbiesReducer,
    membershipState:membershipReducer,
    profileReducer:profileReducer,
    connectionState:connectionReducer,
    notificationState:notificationsReducer,
    projectState:projectReducer,
    portfolioState:portfolioReducer,
    cvReducer : cvReducer,
    postState:postReducer,
    myStuffState:myStuffReducer,
    settingState:settingReducer
});
